<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_PM.id==0">Add </h5>
    <h5 class="card-title" *ngIf="inner_PM.id>0">Edit  </h5>
    <br>
    <br>

    <form [formGroup]="PMForm" >

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Title</label>
          <input formControlName="Title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">Enter the title.</small>
        </div>



      </div>
    </form>

    <br />
    <hr />
    <br />


    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

    <button *ngIf="!InProccessing && inner_PM.id==0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>

    <button *ngIf="!InProccessing && inner_PM.id>0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Edit </button>

  </div>
</div>
